import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx'
import { AccountTabletLinkovi } from '../../Components/Account/AccountTabletLinkovi.jsx'
import { RestrictedAccess } from '../../Components/Layout/RestrictedAccess.jsx'

import { CasinoLink } from '../../Components/Layout/CasinoLink.jsx'
import { Wallet2 } from '../../Components/Account/Wallet2.jsx'
import { AccountLinkovi } from '../../Components/Account/AccountLinkovi.jsx'
import { MetaTags } from '../../Components/Layout/MetaTags.jsx'

//import { DatePicker } from '../../Components/Layout/DatePicker.jsx'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import hr from 'date-fns/locale/hr';
registerLocale('hr', hr);
import { GameDetails } from "../../Components/Game/GameDetails.jsx";

export class AccountFreeGames extends React.Component {
    constructor(props) {
        super(props);

        this.submitForm = this.submitForm.bind(this);
        this.setData = this.setData.bind(this);
        this.fetchMore = this.fetchMore.bind(this);
        this.state = casino.states["games"] || {
            to: new Date(),
            from: casino.utils.addDays(new Date(), -7),
            type: 0,
            working: false,
            data: null,
            page: 1,
            buttonToggle: false,
            fromSport: false
        };
        // Reference for info-msg-box
        this.infoRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.getGames = this.getGames.bind(this);
        this.setGames = this.setGames.bind(this);

        this.getGames();
        casino.utils.createPageGoogleTagManagerEvent('Moj Racun', 'Odigrane besplatne igre', 'casino', this.props.user);
    }

    componentDidMount() {

        const sportParam = new URLSearchParams(location.search).get("fromsport");
        if (sportParam && sportParam == "1") {
            this.setState({ fromSport: true });
        }
        window.scrollTo(0, 0);

        // Event listener for info button
        if (this.state.buttonToggle) {
            document.addEventListener("mousedown", this.handleClickOutside);
        }
    }

    // function for click outside of info-symbol or msg-box
    handleClickOutside(event) {
        if (this.infoRef.current && !this.infoRef.current.contains(event.target)) {
            this.setState({ buttonToggle: false });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.buttonToggle && !prevState.buttonToggle) {
            document.addEventListener("mousedown", this.handleClickOutside);
        } else if (!this.state.buttonToggle && prevState.buttonToggle) {
            document.removeEventListener("mousedown", this.handleClickOutside);
        }
    }

    // remove event listener
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    // function for toggle info button and msg-box
    toggleButton = () => {
        this.setState((prevState) => ({ buttonToggle: !prevState.buttonToggle }));
    };

    getGames() {
        this.props.showLoadingFn(true);
        var promises = Promise.all([casino.repos.gamesForFilterRepo.list(), casino.repos.gameRepo.list().then(this.props.unpackGamesListFn)]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setGames, function (reason) { });
    }

    setGames(data) {
        var allGames = [];
        Object.keys(data[0]).map(x => allGames.push(data[0][x] + "||@@||" + x));
        allGames.sort();

        this.setState({ games: allGames, gamesFull: data[1] });
        this.props.showLoadingFn(false);
    }

    componentWillUnmount() {
        this.props.showLoadingFn(false);
    }

    setData(data) {
        this.setState({ data: data[0], page: 1 })
    }

    submitForm(e) {
        var that = this;

        e.preventDefault();
        this.props.showLoadingFn(true);
        this.setState({ working: true, page: 1 })

        casino.repos.playerFreeGamesRepo.list(casino.utils.dateToIso(this.state.from), casino.utils.dateToIso(this.state.to), this.state.type, 1).then(function (data) {
            that.setState({ working: false, data: data.items, hasMore: data.hasMore })
            that.props.showLoadingFn(false);
        });
    }
    fetchMore() {
        var that = this;
        this.props.showLoadingFn(true);
        var page = (this.state.page + 1)
        this.setState({ working: true });

        casino.repos.playerFreeGamesRepo.list(casino.utils.dateToIso(this.state.from), casino.utils.dateToIso(this.state.to), this.state.type, page).then(function (data) {
            that.setState({ working: false, data: that.state.data.concat(data.items), hasMore: data.hasMore, page: page })
            that.props.showLoadingFn(false);
        });
    }

    renderTran(x) {

        let game = this.state.gamesFull.find(it => it.id == x.gameId);
        return <tr key={x.transactionId + x.datum} className="horizontal-lines">
            <td>
                <div className="game-played">
                    {game && <NavLink to={{ pathname: '/account/free-games/playgame/' + this.props.brands[game.bID].nameNormalizirano + '/' + casino.utils.normalizeString(game.n) }}><img src="content/images/assets/btn_play.png" className="game-play-icon" /> </NavLink>}
                    {!game && <img src="content/images/assets/btn_play_disabled.png" className="game-play-icon" />}
                    <div className="game-played-name">

                        <span className="text">{x.game}</span>

                    </div>
                </div>
            </td>
            <td><span className="text text-1  text-left">{casino.utils.dateToDateString(new Date(x.datum))} {casino.utils.dateToTimeString(new Date(x.datum))}</span></td>
            <td className="text-bold">
                <div className="main-currency">{casino.utils.numberWithCurrencyFromated(x.win, x.valuta)}</div>
            </td>
        </tr >
    }

    render() {
        var pathName = this.props.route.match.url;

        if (this.props.user) {
            return (
                <>
                    {!this.redirectDone && this.state.redirectTo && <Redirect to={{ pathname: this.state.redirectTo, state: this.state.redirectToState }} />}
                    {this.redirectDone = true}
                    <MetaTags title="Odigrane Besplatne Igre | SuperSport Casino" description={" "} />

                    <Route exact path={pathName} render={(route) =>
                        (<Header key="header" {...this.state} {...this.props} detailsHeader="true" disableBrowserBack={true} headerText={"Igre"} headerBackUrl={this.props.getHomePathFn(this.props.route.location, '/account')}></Header>)} />
                    <div className="flex margin-1p-on-tablet">
                        {!this.state.fromSport && <AccountTabletLinkovi {...this.props} />}
                        <div id="page-wrapper" className="white flex-expand-1 border-on-tablet no-padding" style={{ minHeight: '400px' }}>
                            <div className="header-2">
                                <h1 className="text">Odigrane besplatne igre</h1>
                            </div>
                            <div className="clearfix flex-equal-size maximum">
                                <div className="" style={{ minHeight: '600px' }}>
                                    <div className="padding-sides-medium ">
                                        <form onSubmit={this.submitForm} >

                                            <div className="input-group v2 v5 margin-top-small clearfix">

                                                <select required className="input-group--input " value={this.state.type} onChange={(e) => this.setState({ type: e.target.value })} >
                                                    <option value="0">Sve igre</option>
                                                    {this.state.games && this.state.games.map(x => <option key={x} value={x.split('||@@||')[1]}>{x.split('||@@||')[0]}</option>)}
                                                </select>

                                                <span className="input-group--prefix">Igra:</span>
                                                <span className="input-group--suffix"></span>
                                            </div>

                                            <div className="input-group v2  v5 margin-top-small clearfix">
                                                <DatePicker minDate={new Date(Date.now() - 50 * 24 * 60 * 60 * 1000)} dateFormat="dd.MM.yyyy." calendarStartDay={1} className="input-group--input date-picker" locale="hr" selected={this.state.from} onChange={(date) => this.setState({ from: date })} />
                                                <span className="input-group--prefix">Datum od:</span>
                                                <span className="input-group--suffix"></span>
                                            </div>

                                            <div className="input-group v2  v5 margin-top-small clearfix">
                                                <DatePicker dateFormat="dd.MM.yyyy." calendarStartDay={1} className="input-group--input date-picker" locale="hr" selected={this.state.to} onChange={(date) => this.setState({ to: date })} />
                                                <span className="input-group--prefix">Datum do:</span>
                                                <span className="input-group--suffix"></span>
                                            </div>

                                            <div className="margin-top margin-bottom"></div>
                                            <div className="margin-top">
                                                <div >
                                                    <button type="submit" disabled={this.state.working} className="as-block btn fill large gray-blue">Prikaži</button>
                                                </div>
                                            </div>
                                            <div className="margin-top margin-bottom"></div>
                                        </form>

                                        <br />

                                        <hr />
                                        <br />

                                        <b className="text">Odigrane besplatne igre:</b>
                                        <br />
                                        <br />
                                        {!this.state.data && <span className="text">Pritisnite prikaži za početak...</span>}
                                        {this.state.data && this.state.data.length == 0 && <span className="text">Nisu pronađene igre.</span>}
                                    </div>
                                    {this.state.data && this.state.data.length > 0 &&
                                        <table className="table-1 v2 v3 played-games" >
                                            <thead><tr>
                                                <th className="text-left text text-6">Igra</th>
                                                <th className="  text-left text text-6 ">Datum</th>
                                                <th className="text-right text text-6">Dobitak</th>
                                            </tr></thead>
                                            <tbody>
                                                {this.state.data.map(this.renderTran.bind(this))}
                                            </tbody>
                                        </table>
                                    }

                                    {this.state.hasMore &&
                                        <div className="text-center" >
                                            <br></br>
                                            <button disabled={this.state.working} className="btn fill medium gray-blue" onClick={this.fetchMore}>Učitaj još...</button>
                                            <br></br>
                                        </div>
                                    }

                                    {/* {this.state.data && this.state.data.length > 0 &&
                                        <div className="padding-sides-medium margin-top text-center">
                                            <span style={{ fontStyle: 'italic', fontSize: '12px' }}>
                                                * Za podatke o odigranim igrama koje su starije od 50 dana , obratite se službi za korisnike na e-mail adresu ssport@supersport.hr</span>
                                        </div>
                                    }
                                    <br></br> */}
                                     <div className="padding-sides-medium margin-top">
                                        <span style={{ fontWeight: 'bold', fontSize: '12px' }}>
                                            * Za podatke o odigranim igrama koje su starije od 50 dana, obratite se službi za korisnike na e-mail adresu ssport@supersport.hr</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <GameDetails loadGames={true} {...this.props} {...this.state} routePrefix="/account/free-games"></GameDetails>
                </>
            )
        } else {
            return (
                <>
                    <Header key="header" {...this.state} {...this.props}></Header>
                    <RestrictedAccess {...this.props} />

                    {!this.redirectDone && this.state.redirectTo && <Redirect to={{ pathname: this.state.redirectTo, state: this.state.redirectToState }} />}
                    {this.redirectDone = true}
                </>
            )
        }
    }
};